import { createRouter, createWebHistory } from "vue-router";
import { routes } from "./routes";
import { authMiddleware, permissionMiddleware } from "./middleware";
import { usePageTitle } from "@/composables/usePageTitle";

const { updateTitle } = usePageTitle();

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    window.scrollTo(0, 0);
  },
});

router.beforeEach(authMiddleware);
router.beforeEach(permissionMiddleware);

router.afterEach(updateTitle);

// Глобальный обработчик для маршрутов с несуществующими именами
const originalResolve = router.resolve;
router.resolve = (to) => {
  try {
    // Привязываем к router, а не к лексическому this (в модуле = undefined).
    return originalResolve.call(router, to);
  } catch (error) {
    console.warn(`Попытка навигации к несуществующему маршруту: ${JSON.stringify(to)}`);
    // Возвращаем маршрут на главную страницу вместо ошибки
    return originalResolve.call(router, { name: "main" });
  }
};

export default router;
